import { formatDateTime } from "../../../../../common/utils"
import { EVENT_TYPES } from "../../data"

export function isBookingRescheduleEvent(event) {
  return event?.type === EVENT_TYPES.bookingReschedule
}

export function getBookingRescheduleEventTitle() {
  return "Booking rescheduled"
}

export function getBookingRescheduleEventDetail(event) {
  const previous = event?.previous_datetime
    ? formatDateTime(event.previous_datetime)
    : null
  const updated = event?.new_datetime
    ? formatDateTime(event.new_datetime)
    : null
  return {
    previous,
    updated,
    reason: event?.reason || "",
  }
}
